import { createAppRequest } from '@/services/request';

const request = createAppRequest();

export interface OpenPlatformTokenResult {
  accessToken: string;
  exp: number;
  iat: number;
}

export function getOpenPlatformToken() {
  return request<OpenPlatformTokenResult>('/bff/open-platform/token', {
    method: 'GET',
  });
}
